// export const baseUrl = "http://biyogaacademy.org/kittrow/";
export const baseUrl = "https://kittrowinvest.com/backendinvest/";
// export const baseUrl = 'https://sofineer.com/kttoapin/';
